import React from 'react';
import { X } from 'lucide-react';
import SearchBar from './SearchBar';

/**
 * Reusable search bar for tables. Renders above the table with optional "Active filters" / "Clear all" bar.
 * @param {string} value - Controlled search value
 * @param {function} onChange - (e) => void
 * @param {string} [placeholder='Search...']
 * @param {boolean} [hasActiveFilters=false]
 * @param {function} [onClearFilters] - Called when "Clear all" is clicked
 * @param {number} [resultCount] - If set, shows "Clear all (resultCount results)" when hasActiveFilters
 * @param {string} [className]
 * @param {boolean} [hideSearchBar=false] - When true, only render active filters bar (search is rendered elsewhere, e.g. in page toolbar)
 */
function TableSearchBar({
  value,
  onChange,
  placeholder = 'Search...',
  hasActiveFilters = false,
  onClearFilters,
  resultCount,
  className = '',
  hideSearchBar = false,
}: any) {
  return (
    <div className={`mb-4 space-y-3 ${className}`}>
      {!hideSearchBar && <SearchBar value={value} onChange={onChange} placeholder={placeholder} />}
      {hasActiveFilters && onClearFilters && (
        <div className="flex items-center gap-2 flex-wrap p-3 bg-dark-base/50 rounded-lg border border-dark-border">
          <span className="text-xs font-medium text-slate-300">Active filters:</span>
          {value && (
            <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-md text-xs font-medium bg-vivid-red text-white shadow-sm">
              <span>Search: &quot;{value}&quot;</span>
              <button
                type="button"
                onClick={() => onChange({ target: { value: '' } })}
                className="hover:bg-red-600 rounded p-0.5 transition-colors"
                aria-label="Clear search"
              >
                <X className="w-3 h-3" />
              </button>
            </span>
          )}
          <button
            type="button"
            onClick={onClearFilters}
            className="ml-auto text-red-400 bg-red-900/20 hover:text-red-300 font-medium px-2 py-1 hover:bg-red-900/40 rounded transition-colors"
          >
            {resultCount != null ? `Clear all (${resultCount} results)` : 'Clear all'}
          </button>
        </div>
      )}
    </div>
  );
}

export default TableSearchBar;
